import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { Bed, CheckCircle, XCircle } from 'lucide-react';
import { usePublicContent } from '@/lib/content';

const HOTEL_IMG = 'https://images.unsplash.com/photo-1552858725-693709cc17c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiZWRyb29tJTIwZGFya3xlbnwwfHx8fDE3NzYxMTAyOTh8MA&ixlib=rb-4.1.0&q=85';

export default function AccommodationPage() {
  const { user } = useAuth();
  const { accommodation } = usePublicContent();

  return (
    <div className="max-w-3xl mx-auto animate-fade-in" data-testid="accommodation-page">
      <h1 className="text-2xl font-semibold tracking-tight text-slate-50 mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>{accommodation.heading}</h1>
      <p className="text-sm text-slate-400 mb-8">{accommodation.description}</p>

      <div className="rounded-xl overflow-hidden border border-slate-700/50 mb-6">
        <img src={HOTEL_IMG} alt="Overnatning" className="w-full h-48 object-cover" />
      </div>

      <div className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-6 mb-6">
        <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">Din status</h3>
        <div className="flex items-center gap-3">
          {user?.overnight_allowed ? (
            <>
              <CheckCircle className="w-5 h-5 text-emerald-400 flex-shrink-0" />
              <div>
                <p className="text-sm text-slate-200">Overnatning er mulig for dig</p>
                <p className="text-xs text-slate-400">Du kan ønske overnatning i dit RSVP</p>
              </div>
            </>
          ) : (
            <>
              <XCircle className="w-5 h-5 text-slate-500 flex-shrink-0" />
              <div>
                <p className="text-sm text-slate-300">Overnatning er ikke inkluderet</p>
                <p className="text-xs text-slate-500">Kontakt arrangøren, hvis du har spørgsmål</p>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-6">
        <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">Detaljer</h3>
        <div className="space-y-3 text-sm text-slate-300">
          <p>{accommodation.practical_information}</p>
          <p className="text-slate-500 text-xs">Har du spørgsmål, så se Spørgsmål og svar eller kontakt arrangøren.</p>
        </div>
      </div>
    </div>
  );
}
